<script>
import { ref, onMounted, toRefs, watch, reactive } from "vue";
export default {
	props: ["windowHeight", "scrollTop"],
	setup(props) {
		const { windowHeight, scrollTop } = toRefs(props);
		const indicator = ref(false);
		const isSelect = reactive({
			select: [true, false, false, false, false, false, false, false],
		});
		const isViewed = [
			false,
			false,
			false,
			false,
			false,
			false,
			false,
			false,
		];
		watch(
			() => scrollTop.value,
			(nv, ov) => {
				if (nv > 23.3 * windowHeight.value) {
					indicator.value.style.opacity = 0;
				} else if (nv > 23 * windowHeight.value) {
					indicator.value.style.opacity = 1;
					isSelect.select = [
						false,
						false,
						false,
						false,
						false,
						false,
						false,
						true,
					];
					if (!isViewed[7]) {
						gtag("config", process.env.VUE_APP_GAID, {
							page_title: "預約賞車",
						});
						isViewed[7] = true;
					}
				} else if (nv > 19.5 * windowHeight.value) {
					isSelect.select = [
						false,
						false,
						false,
						false,
						false,
						false,
						true,
						false,
					];
					if (!isViewed[6]) {
						gtag("config", process.env.VUE_APP_GAID, {
							page_title: "車系輪播",
						});
						isViewed[6] = true;
					}
				} else if (nv > 17 * windowHeight.value) {
					isSelect.select = [
						false,
						false,
						false,
						false,
						false,
						true,
						false,
						false,
					];
					if (!isViewed[5]) {
						gtag("config", process.env.VUE_APP_GAID, {
							page_title: "前衛美學",
						});
						isViewed[5] = true;
					}
				} else if (nv > 14 * windowHeight.value) {
					isSelect.select = [
						false,
						false,
						false,
						false,
						true,
						false,
						false,
						false,
					];
					if (!isViewed[4]) {
						gtag("config", process.env.VUE_APP_GAID, {
							page_title: "車款性能",
						});
						isViewed[4] = true;
					}
				} else if (nv > 9.5 * windowHeight.value) {
					isSelect.select = [
						false,
						false,
						false,
						true,
						false,
						false,
						false,
						false,
					];
					if (!isViewed[3]) {
						gtag("config", process.env.VUE_APP_GAID, {
							page_title: "智慧內裝",
						});
						isViewed[3] = true;
					}
				} else if (nv > 4.5 * windowHeight.value) {
					isSelect.select = [
						false,
						false,
						true,
						false,
						false,
						false,
						false,
						false,
					];
					if (!isViewed[2]) {
						gtag("config", process.env.VUE_APP_GAID, {
							page_title: "美學外觀",
						});
						isViewed[2] = true;
					}
				} else if (nv > 2 * windowHeight.value) {
					isSelect.select = [
						false,
						true,
						false,
						false,
						false,
						false,
						false,
						false,
					];
					if (!isViewed[1]) {
						gtag("config", process.env.VUE_APP_GAID, {
							page_title: "車款簡介",
						});
						isViewed[1] = true;
					}
				} else {
					isSelect.select = [
						true,
						false,
						false,
						false,
						false,
						false,
						false,
						false,
					];
					if (!isViewed[0]) {
						// gtag("config", process.env.VUE_APP_GAID, {
						// 	page_title: "首頁",
						// });
						isViewed[0] = true;
					}
				}
			}
		);
		return {
			isSelect,
			indicator,
		};
	},
};
</script>

<template>
	<div id="indicator-box" class="indicator-box" ref="indicator">
		<div
			:class="['indicator', { selected: n }]"
			v-for="(n, idx) in isSelect.select"
			:key="idx"
		></div>
		<span class="slash"></span>
		<span class="text text_en_thin">THE 4 Gran Coupé</span>
	</div>
</template>

<style lang="sass" scoped>
.indicator-box
	position: fixed
	bottom: calc(2vw + 22.4px)
	left: calc(3.6vw + 16px)
	// display: flex
	// justify-content: center
	// align-items: center
	z-index: 100
.indicator
	display: inline-block
	width: 6px
	height: 3px
	border-radius: 25%
	margin-left: 6px
	box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15)
	background-color: #fff
	transition: width 0.5s
	vertical-align: middle
	&.selected
		width: 18px
		background-color: #0653b6
.indicator:nth-child(1)
	margin-left: 0
.slash
	display: inline-block
	width: 1.37vw
	height: 0.5px
	margin: 0px 10px
	box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.3)
	background-color: #fff
	vertical-align: middle
	transform: scaleY(0.7)
.text
	display: inline-block
	text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3)
	font-size: 1.5rem
	letter-spacing: 0.9px
	vertical-align: middle
@media screen and (max-width: 992px)
	.indicator-box
		// bottom: 3.125vw
		// left: 4.43vw
		.slash, .text
			display: none
@media screen and (max-width: 768px)
	.indicator-box
		.indicator
			width: 3px
			height: 1.5px
			margin-left: 5px
			&.selected
				width: 9px
</style>
